import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountSettingComponent } from './account-setting/account-setting.component';
import { SignUpComponent } from './sign-up.component';



@NgModule({
  declarations: [
    SignUpComponent,
    AccountSettingComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class SignUpModule { }
